module.exports = __webpack_public_path__ + "static/media/google.3e4f9779.png";